/**
 * Admin info page
 *
 * created by Ty D'Angelo 10/17/2022
 */

import * as React from "react";
import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookies";
import axios from "axios";
import ViewAdmin from "../admin/ViewAdmin";
import { CenteredContainer } from "../ui/BaseComponents";
import { decodeJWTBearer } from "../utils/decodeJWT";

export default function Admin() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // GET
  const fetchData = async () => {
    try {
      const JWT = await getCookie("ea1-auth");
      const decoded = decodeJWTBearer(JWT);
      const id = decoded.id;
      const { data } = await axios(`https://ea1-dev.azurewebsites.net/api/admin/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      setData(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      // alert("error fetching data");
      console.log(e);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CenteredContainer>
      <ViewAdmin data={data} isLoading={isLoading} />
    </CenteredContainer>
  );
}
